module.exports = __webpack_public_path__ + "media/images/pages/home_featured/contribute-upload-icon-beaaa5f2bbe9524b162487f02fb6fe6b.png";